import { render, staticRenderFns } from "./HowItWorks.vue?vue&type=template&id=d926e630&scoped=true&"
var script = {}
import style0 from "./HowItWorks.vue?vue&type=style&index=0&id=d926e630&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d926e630",
  null
  
)

export default component.exports